import { eanCheckDigit } from '../scale/barcode'

/** UPC-E (8 digits, number system 0 or 1) written out as its UPC-A, or null when it is not a valid UPC-E. */
export const upcEToUpcA = (code: string): string | null => {
  if (!/^[01]\d{7}$/.test(code)) return null
  const [ns, d1, d2, d3, d4, d5, d6, check] = code
  const body =
    d6 <= '2' ? `${d1}${d2}${d6}0000${d3}${d4}${d5}` : d6 === '3' ? `${d1}${d2}${d3}00000${d4}${d5}` : d6 === '4' ? `${d1}${d2}${d3}${d4}00000${d5}` : `${d1}${d2}${d3}${d4}${d5}0000${d6}`
  const upcA = `${ns}${body}${check}`
  return eanCheckDigit(upcA.slice(0, 11)) === Number(check) ? upcA : null
}

/**
 * The forms one retail code can be scanned or saved in: a UPC-A is the EAN-13 with a leading 0, and a UPC-E is a
 * short UPC-A. Readers differ in which they report, so a lookup tries them all. Anything else is itself only.
 */
export const productCodeVariants = (code: string): string[] => {
  const c = code.trim()
  if (/^\d{12}$/.test(c)) return [c, `0${c}`]
  if (/^0\d{12}$/.test(c)) return [c, c.slice(1)]
  const upcA = /^\d{8}$/.test(c) ? upcEToUpcA(c) : null
  return upcA ? [c, upcA, `0${upcA}`] : [c]
}
